import React from 'react'
import { Container, Image } from 'react-bootstrap'
import photo from '../../assets/images/illustration-dashboard.png'
import "./content.scss"

const Content = () => {
  return (
    <Container className='text-center'>
        <Image src={photo} fluid id='contentImg' alt='dashboard-page'/>
    </Container>
  )
}

export default Content
